import { useEffect, useState } from 'react'
import { WebdoorList } from 'models/webdoor'
import { getWebdoors } from 'services/webdoor'

export const useWebdoorController = () => {
  const [webdoors, setWebdoors] = useState<WebdoorList>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getWebdoors().then(data => {
      setWebdoors(data)
      setLoading(false)
    })
  }, [])

  return {
    webdoors,
    loading,
  }
}
